import { render, staticRenderFns } from "./UserAccountIndex.vue?vue&type=template&id=8f4f017a&"
import script from "./UserAccountIndex.vue?vue&type=script&lang=js&"
export * from "./UserAccountIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports